/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AllUserObjects } from './AllUserObjects';
import {
    AllUserObjectsFromJSON,
    AllUserObjectsFromJSONTyped,
    AllUserObjectsToJSON,
    AllUserObjectsToJSONTyped,
} from './AllUserObjects';
import type { JoinRequestCreatedResponse } from './JoinRequestCreatedResponse';
import {
    JoinRequestCreatedResponseFromJSON,
    JoinRequestCreatedResponseFromJSONTyped,
    JoinRequestCreatedResponseToJSON,
    JoinRequestCreatedResponseToJSONTyped,
} from './JoinRequestCreatedResponse';

/**
 * 
 * @export
 * @interface AddUserResponseV1
 */
export interface AddUserResponseV1 {
    /**
     * 
     * @type {string}
     * @memberof AddUserResponseV1
     */
    status: string;
    /**
     * 
     * @type {AllUserObjects}
     * @memberof AddUserResponseV1
     */
    user_data?: AllUserObjects;
    /**
     * 
     * @type {JoinRequestCreatedResponse}
     * @memberof AddUserResponseV1
     */
    join_request?: JoinRequestCreatedResponse;
}

/**
 * Check if a given object implements the AddUserResponseV1 interface.
 */
export function instanceOfAddUserResponseV1(value: object): value is AddUserResponseV1 {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function AddUserResponseV1FromJSON(json: any): AddUserResponseV1 {
    return AddUserResponseV1FromJSONTyped(json, false);
}

export function AddUserResponseV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): AddUserResponseV1 {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'user_data': json['user_data'] == null ? undefined : AllUserObjectsFromJSON(json['user_data']),
        'join_request': json['join_request'] == null ? undefined : JoinRequestCreatedResponseFromJSON(json['join_request']),
    };
}

export function AddUserResponseV1ToJSON(json: any): AddUserResponseV1 {
    return AddUserResponseV1ToJSONTyped(json, false);
}

export function AddUserResponseV1ToJSONTyped(value?: AddUserResponseV1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'user_data': AllUserObjectsToJSON(value['user_data']),
        'join_request': JoinRequestCreatedResponseToJSON(value['join_request']),
    };
}

